import { CustomColumn } from '../../types/customColumn';
import { ISupplier } from '../../types/supplier/supplierInterfaces';

export const supplierColumns: CustomColumn<ISupplier>[] = [
  /**
   * 🏢 Proveedor
   */
  {
    Header: 'Proveedor',
    accessor: 'name',
    customCell: ({ row }) => (
      <div className="min-w-[240px] max-w-[320px]">
        <div className="font-medium text-black dark:text-white">
          {row.original.name || '—'}
        </div>

        <div
          className="
            mt-1
            text-xs
            leading-5
            text-gray-500
            dark:text-gray-400
            whitespace-normal
            break-words
          "
        >
          {row.original.entityTypeName || '—'} ·{' '}
          {row.original.taxpayerCategoryName || '—'}
        </div>
      </div>
    ),
  },

  /**
   * 🪪 Documento
   */
  {
    Header: 'Documento',
    accessor: 'document',
    customCell: ({ row }) => (
      <div className="min-w-[180px]">
        <span className="font-medium text-black dark:text-white">
          {row.original.document || '—'}
        </span>
      </div>
    ),
  },

  /**
   * 📞 Contacto
   */
  {
    Header: 'Contacto',
    accessor: 'phone',
    customCell: ({ row }) => (
      <div className="min-w-[220px] max-w-[280px]">
        <div className="text-sm font-medium text-gray-700 dark:text-gray-300">
          {row.original.phone || '—'}
        </div>

        <div
          className="
            mt-1
            text-xs
            leading-5
            text-gray-500
            dark:text-gray-400
            whitespace-normal
            break-words
          "
        >
          {row.original.email || '—'}
        </div>
      </div>
    ),
  },

  /**
   * ✅ Estado
   */
  {
    Header: 'Estado',
    accessor: 'status',
    customCell: ({ row }) => (
      <div className="min-w-[140px]">
        <span
          className={`inline-flex rounded-full px-3 py-1 text-sm font-medium ${
            row.original.status
              ? 'bg-green-500 text-white'
              : 'bg-[#DC3545] text-white'
          }`}
        >
          {row.original.status ? 'Activo' : 'Inactivo'}
        </span>
      </div>
    ),
  },
];